import React from 'react'
import './EventListPopover.scss'
import closeIcon from '../../../assets/close.svg'
import ReactTooltip from 'react-tooltip'

export default class EventListPopover extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            newLeft: 0,
            newTop: 0,
        }

        this.popoverRef = React.createRef();
        this.handleClickOutsideOfPopover = this.handleClickOutsideOfPopover.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutsideOfPopover);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutsideOfPopover);
    }

    handleClickOutsideOfPopover(event) {
        if (this.popoverRef && this.popoverRef.current && !this.popoverRef.current.contains(event.target)) {
            this.props.closePopover()
        }
    }

    positionPopover = () => {
        let rect = this.popoverRef.current.getBoundingClientRect()
        let { left, top } = this.props

        if ((left + rect.width + 15) >= window.innerWidth) { // Out on the right
            let newLeft = left - rect.width - 45
            this.setState({ newLeft: newLeft })
        }

        if (top + rect.height + 50 >= window.innerHeight) {
            let newTop = top - rect.height + 33
            this.setState({ newTop: newTop })
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.setState({ newLeft: 0, newTop: 0 })
        }
        ReactTooltip.rebuild()
    }

    render() {
        let { top, left, showPopover } = this.props

        if (this.state.newLeft !== 0 || this.state.newTop !== 0) {
            if (this.state.newLeft !== 0) {
                left = this.state.newLeft
            }
            if (this.state.newTop !== 0) {
                top = this.state.newTop
            }
        } else if (showPopover) {
            this.positionPopover()
        }

        return (
            <div className={`event-list-popover ${showPopover ? 'show' : 'hide'}`}
                style={{ top, left }}
                ref={this.popoverRef}>
                <div className="event-list-popover-header">
                    <span>
                        <span className='header-date'>{this.props.date}</span>
                        <span className='header-day'>{this.props.day}</span>
                    </span>
                    <img src={closeIcon} alt="close" onClick={this.props.closePopover} />
                </div>
                <div className="event-list-popover-body">
                    {this.props.events ? this.props.events.map((event, index) => (
                        <div className='fc-daygrid-dot-event' key={index} onClick={() => {
                            ReactTooltip.hide()
                            this.props.handleEventClick(event, true)
                        }}>
                            <div className='event-dot' style={{ border: `4px solid ${event.extendedProps.color}` }}></div>
                            <span data-tip={event.title} className='event-title'>{event.title}</span>
                        </div>
                    )) : null}
                </div>
            </div>
        )
    }
}
